/**
 * Browser Farm Configuration
 *
 * Provides the API base URL for authenticated browser endpoints
 * (/api/v1/browser/...) used by screencast and agent stream SSE connections.
 */

/**
 * Returns the API base URL for authenticated browser endpoints.
 *
 * For authenticated browser endpoints (/api/v1/browser/...), we use the
 * same origin as other API calls. This avoids CORS issues since the
 * SecurityPolicy already handles this origin.
 *
 * Priority:
 * 1. VITE_API_BASE_URL env var (e.g. "http://localhost:8080/")
 * 2. Current page origin (same-origin in deployed environments)
 */
export function getApiBaseUrl(): string {
  const envUrl = import.meta.env.VITE_API_BASE_URL;
  if (envUrl) {
    const cleaned = (envUrl as string).replace(/\/+$/, '');
    // In dev mode (Vite dev server), use relative paths so requests go through
    // Vite's proxy, avoiding CORS issues with cross-origin SSE requests.
    if (
      import.meta.env.DEV &&
      typeof window !== 'undefined' &&
      window.location.origin !== cleaned
    ) {
      return '';
    }
    return cleaned;
  }
  return typeof window !== 'undefined'
    ? window.location.origin
    : 'http://localhost:8080';
}
